module.exports = __webpack_public_path__ + "img/game_detail_infinity8_express.d20edb1a.jpg";